<template>
  <div
    v-if="listaDomandeRisposte.length > 0"
    class="riepilogo-domande-risposte-log-container"
  >
    <div class="title">{{ intl[$store.state.lang]["title"] }}</div>
    <div class="riepilogo">
      <div
        v-for="(domandaRisposta, index) in listaDomandeRisposte"
        :key="index"
        class="domanda-risposta text-start"
      >
        <div class="domanda">{{ domandaRisposta.question.text }}</div>
        <div class="risposta">{{ domandaRisposta.answer.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
export default {
  name: "riepilogoDomandeRisposteLog",
  mounted() {},
  props: {
    surveyLogId: {
      type: Number,
      default: null,
      required: true,
    },
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        console.log("PAGINA RINGRAZIAMENTO LOADER: ", value);
      },
    },
    onGetDataCallback: {
      type: Function,
      default: (data) => {
        console.log("DATA CALLBACK: ", data);
      },
    },
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    const isGeam = params.get('isGeam');
    let isFromSiav = this.$store.state["libraryWiperConfig"].startFromAnswerId && isGeam == 'true'
    if(!isFromSiav){
    this.getSurveyLogRiepilogo();
    }
  },

  data: function () {
    return {
      intl: intl,
      listaDomandeRisposte: [],
      riepilogoDomandeRisposteLoader: false,
    };
  },
  methods: {
    getSurveyLogRiepilogo() {
      let actualSurveyLogId = this.surveyLogId ||  this.$store.getters.getSurveyLogId
      if (actualSurveyLogId) {
        this.riepilogoDomandeRisposteLoader = true;
        axios
          .get(apiUrls["survey_log_detail"] + actualSurveyLogId)
          .then((response) => {
            if (response.data && response.data.question_done) {
              if (response.data.question_done.length > 0) {
                response.data.question_done.map(
                  (logQuestionDone) => {
                    if (logQuestionDone.answer && logQuestionDone.question) {
                      let domandaRisposta = {};
                      domandaRisposta["answer"] = logQuestionDone.answer;
                      domandaRisposta["question"] = logQuestionDone.question;
                      this.listaDomandeRisposte.push(domandaRisposta)
                    }
                  }
                );
                this.onGetDataCallback(response.data.question_done);
                this.riepilogoDomandeRisposteLoader = false;
              }
            }
          })
          .catch((error) => {
            this.onGetDataCallback(null);
            this.riepilogoDomandeRisposteLoader = false;
          });
      } else {
        this.onGetDataCallback(null);
        this.riepilogoDomandeRisposteLoader = false;
      }
    },
  },
  watch: {
    riepilogoDomandeRisposteLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ riepilogoDomandeRisposte: newValue });
        }
      },
      deep: true,
    },
  },
  computed: {},
};
</script>
